import { Injectable, OnDestroy } from '@angular/core';

import { map, Subject, Subscription, switchMap, tap } from 'rxjs';

import { WireBlockTypeApiEnum } from '../../Wire/enums/wire-block-type.enum';
import { WireService } from '../../Wire/services/wire.service';
import { DistributionService } from '../../../Common/TargetingShared/services/distribution.service';
import { DistributionBlockTypeApiEnum } from '../../../api/distributions/enum/distribution-block-type-api.enum';
import { WireRegion } from '../../../api/wire/enums/wire-region.enum';
import { DistributionApiToWireConverter } from '../converters/distribution-api-to-wire.converter';

export const distributionBlockTypeApiEnumToWireBlockTypeApiEnum: Map<DistributionBlockTypeApiEnum, WireBlockTypeApiEnum> = new Map([
    // [DistributionBlockTypeApiEnum.title, ],
    [DistributionBlockTypeApiEnum.text, WireBlockTypeApiEnum.text],
    [DistributionBlockTypeApiEnum.image, WireBlockTypeApiEnum.image],
    // [DistributionBlockTypeApiEnum.divider, ],
    // [DistributionBlockTypeApiEnum.button, ],
    // [DistributionBlockTypeApiEnum.code, ],
    // [DistributionBlockTypeApiEnum.footer, ],
]);

@Injectable()
export class AmplifyContentService implements OnDestroy {
    private subscriptions: Subscription[] = [];

    $allWires = this.wireService.all$;
    $allDistributions = this.distributionService.getDistributionSummaries();

    private convertDistribution$ = new Subject<{ id: number; wireRegion: WireRegion}>();

    constructor(
        private distributionService: DistributionService,
        private wireService: WireService,
        private distributionApiToWireConverter: DistributionApiToWireConverter
    ) {
        this.subscriptions.push(
            this.convertDistribution$.pipe(
                switchMap(({id, wireRegion}) => this.distributionService.getDistributionById(id).pipe(
                    switchMap(distribution => this.distributionApiToWireConverter.convert(distribution)),
                    map(currentWire => {
                        currentWire.regions = [wireRegion];
                        return currentWire;
                    })
                )),
                tap(wire => this.wireService.createAndRouteToNewWire(wire))
            ).subscribe()
        );
    }

    ngOnDestroy(): void {
        this.subscriptions?.forEach(sub => sub.unsubscribe());
    }

    convertDistributionToWire(distributionId: number, wireRegion: WireRegion) {
        this.convertDistribution$.next({
            id: distributionId,
            wireRegion: wireRegion
        });
    }
}
